import { render, staticRenderFns } from "./px-input-password.vue?vue&type=template&id=6b6af10c&scoped=true&"
import script from "./px-input-password.vue?vue&type=script&lang=ts&"
export * from "./px-input-password.vue?vue&type=script&lang=ts&"
import style0 from "./px-input-password.vue?vue&type=style&index=0&id=6b6af10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6af10c",
  null
  
)

export default component.exports